// 自动聚焦文本框
const autoFocus = {
    inserted(el, binding) {
        // 获取回调函数（通过指令的绑定值传递）
        const callback = binding.value;
        const inputDom = el.querySelector("input") || el.querySelector("textarea");

        if (inputDom) {
            inputDom.focus();
        }

        // 监听点击事件
        const handleClickOutside = (event) => {
            if (!el.contains(event.target)) {
                if (callback && typeof callback === "function") callback(event);
            }
        };

        setTimeout(() => {
            document.addEventListener("click", handleClickOutside);
        }, 100);

        el._handleClickOutside = handleClickOutside;
    },

    unbind(el) {
        // 解绑删除点击事件监听
        document.removeEventListener("click", el._handleClickOutside);
    },
};

// 横向列表拖拽
const draggleScrollX = {
    inserted(el, binding) {
        let isDragging = false;
        let startX = 0;
        let scrollLeft = 0;
        el.classList.add("draggle-horizontal");

        // 添加监听事件-鼠标按下
        const onMouseDown = (event) => {
            isDragging = true;

            // 鼠标位置和初始滚动位置
            startX = event.pageX - el.offsetLeft;
            scrollLeft = el.scrollLeft;

            el.style.cursor = "grabbing";
            el.style.userSelect = "none";
        };

        // 鼠标离开或者松开
        const onMouseUpOrLeave = () => {
            isDragging = false;
            el.style.cursor = "auto";
            el.style.userSelect = "";

            setTimeout(() => {
                const childrenNodes = Array.from(el.children);

                childrenNodes.forEach((childrenNode) => {
                    childrenNode.style.pointerEvents = "all";
                });

                // 粘滞定位
                if (binding.modifiers.snap) {
                    // const maxScrollWidth = el.scrollWidth - el.clientWidth; // 最大滚动宽度
                    const scrollStep = [0]; // 每个值的滚动step
                    childrenNodes.forEach((childrenNode, index) => {
                        const rectWidth = childrenNode.getBoundingClientRect().width;
                        const style = window.getComputedStyle(childrenNode);
                        const nodeWidth = rectWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight);

                        if (index !== childrenNodes.length - 1) {
                            scrollStep[index + 1] = nodeWidth + scrollStep[index];
                        }
                    });

                    const diffScroll = scrollStep.map((step) => Math.abs(step - el.scrollLeft));
                    const minDiffIndex = diffScroll.indexOf(Math.min(...diffScroll));

                    el.scrollTo({ left: scrollStep[minDiffIndex], behavior: "smooth" });
                }
            }, 100);
        };

        // 鼠标移动
        const onMouseMove = (event) => {
            if (!isDragging) return;

            const x = event.pageX - el.offsetLeft;
            const walk = x - startX;
            el.scrollLeft = scrollLeft - walk;

            Array.from(el.children).forEach((childrenNode) => {
                childrenNode.style.pointerEvents = "none";
            });

            // 触发自定义事件，传递当前滚动位置
            const scrollEvent = new CustomEvent("draggle-scroll-x", {
                detail: {
                    scrollLeft: el.scrollLeft,
                },
            });
            el.dispatchEvent(scrollEvent);
        };

        // 设置初始样式
        el.style.cursor = "auto";
        el.style.overflow = "auto";
        el.style.scrollbarWidth = "none";
        el.style.cssText += "::-webkit-scrollbar { display: none; }";

        el._dragEvents = {
            onMouseDown,
            onMouseUpOrLeave,
            onMouseMove,
        };

        el.addEventListener("mousedown", onMouseDown);
        el.addEventListener("mousemove", onMouseMove);
        el.addEventListener("mouseup", onMouseUpOrLeave);
        el.addEventListener("mouseleave", onMouseUpOrLeave);
    },

    unbind(el) {
        const { onMouseDown, onMouseUpOrLeave, onMouseMove } = el._dragEvents || {};

        el.removeEventListener("mousedown", onMouseDown);
        el.removeEventListener("mousemove", onMouseMove);
        el.removeEventListener("mouseup", onMouseUpOrLeave);
        el.removeEventListener("mouseleave", onMouseUpOrLeave);
    },
};

export { autoFocus, draggleScrollX };
